import Collections from './Collections';

export default Collections;



// WEBPACK FOOTER //
// ./src/pages/Collections/index.ts